var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"completed_mark",class:{'is-completed': _vm.evaluation.completed}})}
var staticRenderFns = []

export { render, staticRenderFns }